import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { AppContext } from 'src/app/services/app-context.service';
import Constants from 'src/app/pages/checkout/utils/Constants';

@Pipe({
  name: 'vtechCurrency'
})
export class CustomCurrencyPipe implements PipeTransform {
  siteName: string;
  constructor(
    private currencyPipe: CurrencyPipe,
    private appContext: AppContext
  ) {
    const str = JSON.parse(sessionStorage.getItem('SiteContext') || '{}');
    this.siteName = str.name;
  }

  transform(value: any, args?: any): any {
    if (
      this.siteName == Constants.SiteNames.shamalgroup ||
      this.siteName == Constants.SiteNames.roomantic
    ) {
      return this.currencyPipe.transform(
        value,
        this.appContext.currency?.code,
        this.appContext.currency?.symbol + ' '
      );
    } else {
      return this.currencyPipe.transform(
        value,
        this.appContext.currency?.code,
        this.appContext.currency?.symbol
      );
    }
  }
}
